import "./Biography.css";

function Biography(props) {

    return (
        <div className="biography">
            <p className={props.isMobile ? "biographyText biographyTextMobile" : "biographyText"}> Hi, and welcome to my website, a visual showcase of my work and personal projects. Throughout my career, I've delved into a wide range of subjects through my three core passions: design, engineering, and innovation.</p>
        </div>
    );
}

export default Biography;

